import { useMemo } from "react";
import {
	Chart as ChartJS,
	Filler,
	Legend,
	LineElement,
	PointElement,
	RadialLinearScale,
	Tooltip,
} from "chart.js";
import { Radar } from "react-chartjs-2";

import { SAL2100_R01ItemGroupDto } from "../Dto_SAL2100_R01";

ChartJS.register(
	RadialLinearScale,
	PointElement,
	LineElement,
	Filler,
	Tooltip,
	Legend,
);

export const ItemGroupChart_SAL2100_R01 = ({ data }: { data: SAL2100_R01ItemGroupDto[] }) => {
	const chartData = useMemo(() => ({
		labels: data.map((item) => item.itemGroupNm || item.itemGroup || "미지정"),
		datasets: [{
			label: "매출액",
			data: data.map((item) => item.salesAmount),
			borderColor: "#00c853",
			backgroundColor: "rgba(0, 200, 83, 0.20)",
			pointBackgroundColor: "#00c853",
			borderWidth: 2,
		}],
	}), [data]);

	return (
		<div className="h-[300px] w-full border border-gray-300 p-2">
			<Radar
				data={chartData}
				options={{
					maintainAspectRatio: false,
					responsive: true,
					plugins: { legend: { position: "bottom" } },
					scales: { r: { beginAtZero: true } },
				}}
			/>
		</div>
	);
};
